import React, { useEffect, useState } from "react";
import "../../App.css";
import { whitearrowicon } from "../../assets/Exportimageicon";
import { useNavigate } from "react-router-dom";
import service from "../../services/service";
import endpoints from "../../services/endpoints";

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState("overview");
  const [loading, setLoading] = useState(true);

  const [missionLoading, setMissionLoading] = useState(false);
  const [ongoingMissions, setOngoingMissions] = useState([]);
  const [completedMissions, setCompletedMissions] = useState([]);

  const [overviewData, setOverviewData] = useState({
    total_distance_covered: {
      value: 0,
      unit: "KM",
    },
    active_missions: {
      value: 0,
      label: "Ongoing",
    },
    completed_missions: {
      value: 0,
      label: "Total",
    },
  });

  const navigate = useNavigate();

  const fetchDashboardOverview = async () => {
    try {
      setLoading(true);

      const response = await service.get(endpoints.dashboard.overview);

      if (response?.data?.success) {
        setOverviewData(response.data.data);
      }
    } catch (error) {
      console.error("Dashboard Overview Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardOverview();
  }, []);

  const fetchMyChallenges = async () => {
    try {
      setMissionLoading(true);

      const response = await service.get(endpoints.profile.myChallenges);

      const data = response?.data?.data;

      setOngoingMissions(data?.ongoingMissions || []);
      setCompletedMissions(data?.completedMissions || []);
    } catch (error) {
      console.error(error);
    } finally {
      setMissionLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === "activemission") {
      fetchMyChallenges();
    }
  }, [activeTab]);

  return (
    <div className="profile-page">
      <h1 className="profile-page-title">Dashboard</h1>

      <div className="profile-tabs">
        <button
          className={`profile-tab ${activeTab === "overview" ? "active" : ""}`}
          onClick={() => setActiveTab("overview")}
        >
          Overview
        </button>

        <button
          className={`profile-tab ${
            activeTab === "activemission" ? "active" : ""
          }`}
          onClick={() => setActiveTab("activemission")}
        >
          Active Mission
        </button>
      </div>

      {activeTab === "overview" && (
        <>
          <div className="activity-table">
            <div style={{ color: "white" }} className="activity-header">
              <span>Total Distance Covered</span>

              <span>
                {loading
                  ? "..."
                  : overviewData?.total_distance_covered?.value?.toFixed(
                      2,
                    )}{" "}
                <span style={{ color: "#7d7d7d" }}>
                  {overviewData?.total_distance_covered?.unit}
                </span>
              </span>
            </div>
          </div>

          <div
            className="activity-table mt-4"
            onClick={() => setActiveTab("activemission")}
            style={{ cursor: "pointer" }}
          >
            <div style={{ color: "white" }} className="activity-header">
              <span>Active Missions</span>

              <span>
                {loading ? "..." : overviewData?.active_missions?.value}{" "}
                <span style={{ color: "#7d7d7d" }}>
                  {overviewData?.active_missions?.label}
                </span>
                <img src={whitearrowicon} alt="" />
              </span>
            </div>
          </div>

          <div
            className="activity-table mt-4"
            onClick={() => setActiveTab("activemission")}
            style={{ cursor: "pointer" }}
          >
            <div style={{ color: "white" }} className="activity-header">
              <span>Completed Missions</span>

              <span>
                {loading ? "..." : overviewData?.completed_missions?.value}{" "}
                <span style={{ color: "#7d7d7d" }}>
                  {overviewData?.completed_missions?.label}
                </span>
                <img src={whitearrowicon} alt="" />
              </span>
            </div>
          </div>
        </>
      )}

      {activeTab === "activemission" && (
        <>
          {missionLoading ? (
            <p style={{ color: "#fff" }}>Loading missions...</p>
          ) : (
            <>
              {/* ONGOING MISSIONS */}

              {ongoingMissions?.length > 0 && (
                <>
                  <div className="mission-grid">
                    {ongoingMissions.map((mission) => (
                      <div className="mission-card" key={mission.challengeId}>
                        <div className="mission-card-top">
                          <div className="mission-left">
                            <div className="mission-icon">
                              {" "}
                              <img src="/challenge_icon.svg" alt="strava" />
                            </div>

                            <div>
                              <h3>{mission.challengeName}</h3>

                              <p>
                                {mission.progressPercentage.toFixed(2)}%
                                Completed
                              </p>
                            </div>
                          </div>

                          <span
                            className={`mission-status ${
                              mission.status === "IN_PROGRESS"
                                ? "mission-started"
                                : mission.status === "COMPLETED"
                                  ? "mission-completed"
                                  : mission.status === "PAUSED"
                                    ? "mission-paused"
                                    : ""
                            }`}
                          >
                            {mission.status}
                          </span>
                        </div>

                        <div className="mission-info">
                          <div>
                            <p>Completed Distance</p>
                            <h2>{mission.completedDistance} KM</h2>
                          </div>

                          <div>
                            <p>Total Distance</p>
                            <h2>{mission.totalDistance} KM</h2>
                          </div>
                        </div>

                        <button
                          className="mission-btn"
                          onClick={() =>
                            navigate(
                              `/all-challenges/mission/${mission.challengeId}`,
                            )
                          }
                        >
                          View Map
                        </button>
                      </div>
                    ))}
                    y
                  </div>
                </>
              )}

              {/* COMPLETED MISSIONS */}

              {completedMissions?.length > 0 && (
                <>
                  <div className="mission-grid">
                    {completedMissions.map((mission) => (
                      <div className="mission-card" key={mission.challengeId}>
                        <div className="mission-card-top">
                          <div className="mission-left">
                            <div className="mission-icon">
                              <img src="/challenge_icon.svg" alt="strava" />
                            </div>

                            <div>
                              <h3>{mission.challengeName}</h3>

                              <p>
                                {mission.progressPercentage.toFixed(2)}%
                                Completed
                              </p>
                            </div>
                          </div>

                          <span className="mission-status mission-completed">
                            COMPLETED
                          </span>
                        </div>

                        <div className="mission-info">
                          <div>
                            <p>Completed Distance</p>
                            <h2>{mission.completedDistance} KM</h2>
                          </div>

                          <div>
                            <p>Total Distance</p>
                            <h2>{mission.totalDistance} KM</h2>
                          </div>
                        </div>

                        <button
                          className="mission-btn"
                          onClick={() =>
                            navigate(
                              `/all-challenges/mission/${mission.challengeId}`,
                            )
                          }
                        >
                          View Map
                        </button>
                      </div>
                    ))}
                  </div>
                </>
              )}

              {ongoingMissions.length === 0 &&
                completedMissions.length === 0 && (
                  <p style={{ color: "#fff" }}>No missions found.</p>
                )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default Dashboard;
